import { useTranslation } from 'react-i18next';

import { monitoringSecurityGroupsService } from '@/api/domains/attendance/monitoring';
import type { SecurityGroupOption } from '@/api/domains/securityGrouping';
import { useCatalogLoader } from '@/hooks/ui/useCatalogLoader';
import type { CatalogLoaderResult } from '@/hooks/ui/useCatalogLoader';
import { useUI } from '@/hooks/ui/useUI';


// Loads the security groups the user can monitor (attendance monitoring panel).
// Mirrors useSecurityGroupsByPermission but hits the monitoring-specific endpoint.
export function useMonitoringSecurityGroups(
  skipFetch: boolean = false,
): CatalogLoaderResult<SecurityGroupOption> {
  const { showNotification } = useUI();
  const { t: translate } = useTranslation();

  return useCatalogLoader(
    (signal) => monitoringSecurityGroupsService.getEnabled(signal),
    (group) => ({ value: String(group.id), label: group.name }),
    [],
    skipFetch,
    () => showNotification('error', translate('common:errors.loadingData'), 5000),
  );
}

export default useMonitoringSecurityGroups;
